export default [
  {
    path: 'M512 950.272L28.672 388.096l208.896-284.672L512 73.728l274.432 29.696 208.896 284.672z',
    fill: '#FFAE00',
  },
  { path: 'M512 950.272L28.672 388.096h966.656z', fill: '#EC6C00' },
  { path: 'M512 950.272L224.256 388.096h575.488z', fill: '#FFAE00' },
  { path: 'M512 73.728L224.256 388.096h575.488z', fill: '#FFEFB4' },
  {
    path: 'M237.568 103.424l-107.52 143.36-101.376 141.312h197.632zM786.432 103.424l107.52 143.36 101.376 141.312H797.696z',
    fill: '#FFAE00',
  },
  {
    path: 'M237.568 103.424l-13.312 284.672L512 73.728zM786.432 103.424l13.312 284.672L512 73.728z',
    fill: '#FED305',
  },
]
